module.exports = __webpack_public_path__ + "static/endingOfSecondBeginningOfThird-27b08cb0df41f8c49aa8c17ce9c255ea.mp3";